import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
/** Vertical "trunk" with per-item elbow + dot + icon + label — the summary
 *  card's read-only step list. Both the Action-group and Transfer summaries
 *  use it so the two cards render identically. */
export function SpineList({ items }) {
    if (items.length === 0)
        return null;
    return (_jsx("ul", { className: "relative", "aria-label": "Steps", children: items.map((item, i) => {
            const first = i === 0;
            const last = i === items.length - 1;
            return (_jsxs("li", { className: "relative flex items-center gap-1.5 py-1 pl-5 text-muted-foreground", children: [_jsx("span", { "aria-hidden": true, className: cn('absolute left-[6px] w-px bg-border', first && last
                            ? 'hidden'
                            : first
                                ? 'top-1/2 bottom-0'
                                : last
                                    ? 'top-0 bottom-1/2'
                                    : 'top-0 bottom-0') }), _jsx("span", { "aria-hidden": true, className: "absolute left-[6px] top-1/2 h-px w-2.5 -translate-y-1/2 bg-border" }), _jsx(item.Icon, { className: "h-3 w-3 flex-shrink-0" }), _jsx("span", { className: "truncate", title: item.title ?? item.label, children: item.label })] }, item.key));
        }) }));
}
//# sourceMappingURL=SpineList.js.map